/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 29879e5237e5
 */

import * as z from "zod";
import { ApiError, ApiError$zodSchema } from "./apierror.js";
import {
  TestTriggerRequest,
  TestTriggerRequest$zodSchema,
} from "./testtriggerrequest.js";
import {
  TestTriggerResponse,
  TestTriggerResponse$zodSchema,
} from "./testtriggerresponse.js";

export type TestTriggerGlobals = { cloud_name?: string | undefined };

export const TestTriggerGlobals$zodSchema: z.ZodType<TestTriggerGlobals> = z
  .object({
    cloud_name: z.string().describe(
      "The cloud name of your product environment.",
    ).optional(),
  });

export type TestTriggerRequestRequest = {
  id: string;
  test_trigger_request?: TestTriggerRequest | undefined;
};

export const TestTriggerRequestRequest$zodSchema: z.ZodType<
  TestTriggerRequestRequest
> = z.object({
  id: z.string().describe("The ID of the trigger to test."),
  test_trigger_request: TestTriggerRequest$zodSchema.optional().describe(
    "The test data for the trigger.",
  ),
});

export type TestTriggerResponseResponse = TestTriggerResponse | ApiError;

export const TestTriggerResponseResponse$zodSchema: z.ZodType<
  TestTriggerResponseResponse
> = z.union([
  TestTriggerResponse$zodSchema,
  ApiError$zodSchema,
]);
